// extracted by mini-css-extract-plugin
export default {"quote":"HighlightedQuote_quote__z2Nla"};